import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import * as styles from "./Navbar.module.css";

export default function PrimaryDrawer({ data }) {
  const [isOpen, setOpen] = useState(false);

  function chunkArray(array, chunkSize = 8) {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      chunkedArray.push(chunk);
    }
    return chunkedArray;
  }

  return (
    <React.Fragment>
      <div
        className={`${styles.nav_link} text-center py-[30px] px-4 xl:p-[30px] relative max-h-full no-underline font-bold cursor-pointer group max-w-7xl`}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
      >
        <div
          className={`${styles.nav_link_top} absolute inset-0 opacity-0 w-full bg-black h-[0.4rem] border-0 rounded-bl-[1.5rem] rounded-br-[1.5rem] transition-opacity duration-300`}
        />
        <span className="text-center text-[#111] tracking-wide">
          {data.title}
        </span>
      </div>
      <div
        id="root"
        className={`absolute top-[87px] right-0 left-0 transition-all duration-300 ease-linear z-10 ${
          isOpen ? "min-h-drawer" : "min-h-0"
        }`}
      >
        {isOpen && (
          <div
            className="flex flex-col text-white w-full h-fit"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocus={() => setOpen(true)}
          >
            <div
              className="overflow-y-scroll noScrollbar overscroll-contain relative flex bg-primary-500 bg-no-repeat bg-center py-[50px] lg:px-5 xl:px-[90px] gap-5 box-border
          justify-between h-min"
            >
              <div className="max-w-[1520px] w-full mx-auto flex px-10">
                <div className="flex flex-col min-w-[220px] w-1/5 xl:w-1/6 min-h-fit h-full border-r-2 border-solid border-r-primary-400 xl:mr-5 2xl:mr-10">
                  {/* Type */}
                  <div className="flex flex-col mb-5">
                    {data.mainLinks.map((mainLink) => (
                      <Link
                        key={mainLink.slug}
                        to={mainLink.slug}
                        className="text-lg xl:text-xl pb-8 last-of-type:pb-0 font-semibold tracking-wide hover:text-secondary-500"
                      >
                        {mainLink.title}
                      </Link>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col min-w-[450px] w-fit xl:w-3/6 h-full px-5 xl:px-10">
                  <div className="flex space-x-10 text-base font-medium tracking-wide text-primary-100">
                    {chunkArray(data?.collections)?.map((collectionArray, index) => (
                      <div className="flex flex-col space-y-4 w-fit relative min-w-[230px]" key={index}>
                        {collectionArray.map((collection) => (
                          <Link
                            key={collection.id}
                            to={collection.slug}
                            className="no-underline hover:text-white hover:font-semibold"
                          >
                            <h5 className="">{collection.title}</h5>
                          </Link>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col w-fit xl:w-2/6 gap-5 h-full">
                  {data.banner && (
                    <Link
                      to={data.banner.buttonLink}
                      className="w-full relative flex min-w-[196px] no-underline text-inherit rounded-lg"
                    >
                      {data.banner.backgroundImage?.gatsbyImageData && (
                        <div className="w-full h-full rounded-lg overflow-hidden z-0">
                          <GatsbyImage
                            image={data.banner.backgroundImage.gatsbyImageData}
                            alt={
                              data.banner.backgroundImage.title ??
                              data.banner.title
                            }
                            loading="lazy"
                            objectFit="cover"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                      )}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
